interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  center?: boolean;
  tone?: "default" | "accent";
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  center = false,
  tone = "default",
}: SectionHeadingProps) {
  return (
    <div className={center ? "flex flex-col items-center text-center" : "flex flex-col"}>
      <span
        className={`inline-flex items-center gap-2 rounded-full border px-3 py-1 text-xs font-medium ${
          tone === "accent"
            ? "border-accent-300 bg-accent-100 text-accent-800"
            : "border-primary-200 bg-primary-100 text-primary-700"
        }`}
      >
        <span className="flex h-3.5 w-3.5 items-center justify-center">
          <i className="ri-price-tag-3-line text-[13px]"></i>
        </span>
        {eyebrow}
      </span>
      <h2 className="mt-4 max-w-3xl font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
        {title}
      </h2>
      {desc ? (
        <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600">{desc}</p>
      ) : null}
    </div>
  );
}